export default "__VITE_ASSET__1127de8c__"